export default __webpack_public_path__ + "static/media/Amanda_Baroni_Elementos_da_Minha_Natureza_11.8398734c.jpg";